import axios from "axios";
import { useEffect } from "react";
import { useUser } from "./AuthContext";
import { getAccesstoken } from "../utils/auth";
/**
 * Fetch {products} from the API.
 * @param {number} skip - Pagination offset.
 * @param {number} limit - Pagination limit.
 * @returns {Promise<Array>} - Returns a promise that resolves to the list of products.
 * @throws {Error} - Throws an error if the API call fails.
 */
// export const fetchData = async (skip = 0, limit = 10) => {
//     try {
//         const response = await axios.get("http://localhost:8000/products", {
//             params: { skip, limit }, // Pass query parameters
//         });
//         return response.data; // Return the response data
//     } catch (error) {
//         throw new Error(error.response?.data?.detail || "Failed to fetch products.");
//     }
// };

const baseUrl = process.env.REACT_APP_BASE_URL; // Base URL from environment
// const token = localStorage.getItem('token');

export const fetchData = async (endpoint, params = {}, access_token) => {
  
  try {
    const response = await axios.get(`${baseUrl}/${endpoint}`, {
      params,
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      withCredentials: true,
    });
    return response.data; 
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to fetch data from" `${endpoint}`);
  }
};

export const fetchUserByUsername = async (username, schema = "public", access_token) => {
  try {
    const response = await axios.get(`${baseUrl}/users/filter/`, {
      params: { username, schema },
      headers: { Authorization: `Bearer ${access_token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

export const updateUser = async (id1, userData, access_token, schema = "public") => {
  try {
    let requestConfig = {
      params: { id: id1, schema },
      headers: {
        'Authorization': `Bearer ${access_token}`
      },
    };

    // Check if userData is FormData
    if (userData instanceof FormData) {
      requestConfig.headers['Content-Type'] = 'multipart/form-data';
      // Make sure the ID is included in the form data
      userData.append('id', id1);
    } else {
      // Handle JSON case as before
      const { first_name, last_name, email, mobile, address, gender, date_of_birth } = userData;

      let convertedAddress;
      if (typeof address === 'string') {
        convertedAddress = { street_address: address };
      } else if (typeof address === 'object') {
        convertedAddress = {
          street_address: address.street_address || '',
          pincode: address.pincode || '',
          state: address.state || '',
        };
      } else {
        convertedAddress = {};
      }

      userData = {
        first_name,
        last_name,
        email,
        mobile,
        address: convertedAddress,
        gender,
        date_of_birth,
        updated_at: new Date().toISOString()
      };
      requestConfig.headers['Content-Type'] = 'application/json';
    }

    const response = await axios.put(
      `${baseUrl}/users/update/`,
      userData,
      requestConfig
    );

    // Update local storage
    try {
      const currentUserDetails = JSON.parse(localStorage.getItem('userDetails'));
      let updatedUserDetails;
      
      if (userData instanceof FormData) {
        // Create an object from FormData
        const formDataObj = {};
        for (let [key, value] of userData.entries()) {
          // Parse the address if it's a JSON string
          if (key === 'address') {
            try {
              formDataObj[key] = JSON.parse(value);
            } catch {
              formDataObj[key] = value;
            }
          } else {
            formDataObj[key] = value;
          }
        }
        updatedUserDetails = {
          ...currentUserDetails,
          ...formDataObj,
          profile_image: response.data.profile_image
        };
      } else {
        updatedUserDetails = {
          ...currentUserDetails,
          ...userData,
          profile_image: response.data.profile_image
        };
      }
      
      localStorage.setItem('userDetails', JSON.stringify(updatedUserDetails));
    } catch (storageError) {
      console.error('Error updating local storage:', storageError);
    }

    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};


// utils/userUtils.js


export const useSetUserId = (username) => {
  const { userId, setUserId } = useUser(); // Access the global userId and setter

  useEffect(() => {
    const getUser = async () => {
      try {
        const user = await fetchUserByUsername(username); // Fetch user based on username
        if (user && user.user_id) {
          setUserId(user.user_id); // Set the global userId state
        }
      } catch (error) {
        console.error("Failed to fetch user:", error);
      }
    };

    if (!userId) { // If userId isn't already set, fetch the user
      getUser();
    }
  }, [username, userId, setUserId]); // Dependency on username and userId
};


export const getCartItemCount = async (access_token, user_id, baseUrl) => {
  if (user_id && access_token) {
    try {
      // const response = await axios.get(
      //   `${baseUrl}/cart_items/count/?user_id=${user_id}`,
      //   {
      //     params: {schema: "public" },
      //     headers: { Authorization: `Bearer ${access_token}` },
      //   }
      // );
      // console.log(response)
      // if (response.data) {
      //   const cartItems = response.data;
      //   return cartItems.reduce((total, item) => total + item.quantity, 0);
      // }
    } catch (error) {
      console.error("Error fetching cart items from user_cart:", error);
    }
  }

  const storedCart = localStorage.getItem("cart");
  if (storedCart) {
    const cart = JSON.parse(storedCart);
    return cart.reduce((total, item) => total + item.quantity, 0);
  }

  return 0;
};

export const sendContactUs = async (data) => {
  const response = await axios.post(`${baseUrl}/general_utility/contact/send-email`, data);
  return response.data;
};